import { render } from "./StatsBulk.vue?vue&type=template&id=36f61f4b"
import script from "./StatsBulk.vue?vue&type=script&lang=js"
export * from "./StatsBulk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__